import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=45e2b309&scoped=true&"
import script from "./Spinner.vue?vue&type=script&lang=js&"
export * from "./Spinner.vue?vue&type=script&lang=js&"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=45e2b309&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e2b309",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45e2b309')) {
      api.createRecord('45e2b309', component.options)
    } else {
      api.reload('45e2b309', component.options)
    }
    module.hot.accept("./Spinner.vue?vue&type=template&id=45e2b309&scoped=true&", function () {
      api.rerender('45e2b309', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/Spinner.vue"
export default component.exports